import React, { useEffect, useState } from 'react';
import { Tabs, Row, Col } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { updateFormField } from 'store/forms/actions';
import ApplicationStatusOverview from 'components/applicationStatusOverview';
const { TabPane } = Tabs;

const CustomTabsTimelineSub = ({ tabs, tabProps, customClass,current, setCurrent, currentSubTab, ...rest }) => {
  const dispatch = useDispatch();
  // const activeTaskName = useSelector(state => state.appTrack?.apptrackDetails?.activeTaskName);
  // const businessKey = useSelector(state => state.appTrack?.apptrackDetails?.businessKey);
   // const [activeTab, setActiveTab] = useState(current);//useState(tabs[0].id);
  const onChange = key => {
    dispatch(
      updateFormField({
        group: 'carrier',
        key:'currentSubTab',
        value: Number(key) ,
      })
    )
    // setActiveTab(key)
  };

  // useEffect(()=> {
  //   setActiveTab(current)
  // },[current])

  return (
    <div className={`${customClass}`}>
      <Tabs
        defaultActiveKey={currentSubTab}
        activeKey={currentSubTab?.toString()}
        onChange={onChange}
        className={`fullwidth-tabs`}
        {...rest}
      >
        {tabs.map(({ label, disabled, Component}, index) => (
          <TabPane 
            key={index} 
            disabled={disabled}
            tab={ 
                   <div  className={`tab-timeline ${
                          disabled ? 'ant-tabs-tab-disabled' : ''
                        }`} 
                    >
                      <div className='tab-timeline-label'>
                        {label}
                      </div>
                  </div>
                  
            }
          >
            {/* {
            <Row>
              <Col span={12}>
                <ApplicationStatusOverview id={businessKey} activeTaskName={activeTaskName}/>
              </Col>
            </Row>} */}
            <Component {...tabProps} />
          </TabPane>
        ))}
      </Tabs>
    </div>
  );
};

export default CustomTabsTimelineSub;
